import { Youtube, Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";

export default function Contact() {
  const handleSubmit = (e) => {
    e.preventDefault();

    const firstName = e.target.firstName.value;
    const lastName = e.target.lastName.value;
    const email = e.target.email.value;
    const phone = e.target.phone.value;
    const message = e.target.message.value;

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=rickypasaribu1967@gmail.com&su=Contact%20from%20${firstName}%20${lastName}&body=Name:%20${firstName}%20${lastName}%0AEmail:%20${email}%0APhone:%20${phone}%0A%0A${message}`;
    window.open(gmailUrl, "_blank");
  };

  return (
    <section
      id="contact"
      className="
        w-full bg-[#E9E3D5] font-[Poppins] rounded-3xl
        flex flex-row justify-center items-center
        px-[2vw] sm:px-[2vw] md:px-[6vw]
        py-3 sm:py-2 md:py-12
        min-h-[36vh] sm:min-h-[18vh] md:min-h-[65vh]
      "
    >
      <div
        className="
          flex flex-row justify-between items-center 
          w-[85%] sm:w-[70%] md:w-[88%] lg:w-[80%]
          flex-wrap
        "
      >
        {/* === KIRI: INFO KONTAK === */}
        <div
          className="
            w-[40%] sm:w-[40%] md:w-1/2 
            text-[#2D435B] 
            space-y-1 sm:space-y-[1px] md:space-y-8 mt-2 sm:mt-[1px] md:mt-6
          "
        >
          <div>
            <h3 className="text-[9px] sm:text-[5px] md:text-2xl font-extrabold mb-1 md:mb-2 flex items-center gap-1 md:gap-2">
              <MapPin size={10} className="sm:w-[6px] sm:h-[6px] md:w-6 md:h-6" /> 
              <span>OFFICE</span>
            </h3>
            <a
              href="https://maps.app.goo.gl/TUV4mZPZToWGRaUf9"
              target="_blank"
              rel="noopener noreferrer"
              className="
                text-[7px] sm:text-[4.5px] md:text-sm 
                leading-tight md:leading-relaxed 
                block hover:underline 
                max-w-[160px] sm:max-w-[150px] md:max-w-[450px]
              "
            >
              Jl. Matraman Raya No.67, RT.5/RW.4, Palmeriam, 
              Kec. Matraman, Kota Jakarta Timur, DKI Jakarta 13140
            </a>
          </div>

          <div>
            <h3 className="text-[9px] sm:text-[5px] md:text-2xl font-extrabold mb-1 md:mb-2">
              Hubungi
            </h3>

            <div className="flex items-center gap-1 sm:gap-[1px] md:gap-2 mb-[1px] md:mb-1">
              <Mail size={10} className="sm:w-[5px] sm:h-[5px] md:w-5 md:h-5" />
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=rickypasaribu1967@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[7px] sm:text-[4.5px] md:text-sm hover:underline"
              >
                rickypasaribu1967@gmail.com
              </a>
            </div>

            <div className="flex items-center gap-1 sm:gap-[1px] md:gap-2">
              <Phone size={10} className="sm:w-[5px] sm:h-[5px] md:w-5 md:h-5" />
              <a
                href="https://wa.me/6282123235368"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[7px] sm:text-[4.5px] md:text-sm hover:underline"
              >
                +62 821-2323-5368
              </a>
            </div>
          </div>

          <div className="flex space-x-1.5 sm:space-x-[2px] md:space-x-4 pt-1 sm:pt-[1px] md:pt-3">
            <a
              href="https://www.youtube.com/@Ricky_Pasaribu"
              target="_blank"
              rel="noopener noreferrer"
              className="p-0.5 sm:p-[1px] md:p-2 border border-[#2D435B] md:border-2 rounded-full hover:bg-[#2D435B] hover:text-white transition"
            >
              <Youtube size={9} className="sm:w-[5px] sm:h-[5px] md:w-[18px] md:h-[18px]" />
            </a>
            <a
              href="https://www.instagram.com/ricky_konsultan/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-0.5 sm:p-[1px] md:p-2 border border-[#2D435B] md:border-2 rounded-full hover:bg-[#2D435B] hover:text-white transition"
            >
              <Instagram size={9} className="sm:w-[5px] sm:h-[5px] md:w-[18px] md:h-[18px]" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61579300034631"
              target="_blank"
              rel="noopener noreferrer"
              className="p-0.5 sm:p-[1px] md:p-2 border border-[#2D435B] md:border-2 rounded-full hover:bg-[#2D435B] hover:text-white transition"
            >
              <Facebook size={9} className="sm:w-[5px] sm:h-[5px] md:w-[18px] md:h-[18px]" />
            </a>
          </div>
        </div>

        {/* === KANAN: FORM KONTAK === */}
<div
  className="
    w-[48%] sm:w-[34%] md:w-[45%]
    bg-[#2D435B] text-white rounded-xl md:rounded-3xl shadow-md md:shadow-lg
    p-2 sm:p-[1px] md:p-8 mt-2 md:mt-0
  "
>
  <h2
    className="
      text-[9px] sm:text-[4px] md:text-2xl
      font-bold text-center text-[#B03A2E]
      mb-2 sm:mb-[1px] md:mb-8
    "
  >
    Contact Us
  </h2>

  <form
    onSubmit={handleSubmit}
    className="space-y-[1px] sm:space-y-[0.1px] md:space-y-4"
  >
    <div className="flex flex-col md:flex-row gap-[0.5px] sm:gap-[0.1px] md:gap-2">
      <div className="w-full">
        <label className="text-[7px] sm:text-[3px] md:text-sm font-semibold mb-[-1px] block">
          First Name *
        </label>
        <input
          type="text"
          name="firstName"
          required
          className="
            w-full bg-transparent border-b border-white
            focus:outline-none focus:border-[#B03A2E]
            py-[0px] sm:py-[0px] md:py-[0.5px]
            text-[7px] sm:text-[3px] md:text-sm
          "
        />
      </div>
      <div className="w-full">
        <label className="text-[7px] sm:text-[3px] md:text-sm font-semibold mb-[-1px] block">
          Last Name *
        </label>
        <input
          type="text"
          name="lastName"
          required
          className="
            w-full bg-transparent border-b border-white
            focus:outline-none focus:border-[#B03A2E]
            py-[0px] sm:py-[0px] md:py-[0.5px]
            text-[7px] sm:text-[3px] md:text-sm
          "
        />
      </div>
    </div>

    <div className="flex flex-col md:flex-row gap-[0.5px] sm:gap-[0.1px] md:gap-2">
      <div className="w-full">
        <label className="text-[7px] sm:text-[3px] md:text-sm font-semibold mb-[-1px] block">
          Email *
        </label>
        <input
          type="email"
          name="email"
          required
          className="
            w-full bg-transparent border-b border-white
            focus:outline-none focus:border-[#B03A2E]
            py-[0px] sm:py-[0px] md:py-[0.5px]
            text-[7px] sm:text-[3px] md:text-sm
          "
        />
      </div>
      <div className="w-full">
        <label className="text-[7px] sm:text-[3px] md:text-sm font-semibold mb-[-1px] block">
          Phone *
        </label>
        <input
          type="tel"
          name="phone"
          required
          className="
            w-full bg-transparent border-b border-white
            focus:outline-none focus:border-[#B03A2E]
            py-[0px] sm:py-[0px] md:py-[0.5px]
            text-[7px] sm:text-[3px] md:text-sm
          "
        />
      </div>
    </div>

    <div>
      <label className="text-[7px] sm:text-[3px] md:text-sm font-semibold mb-[-1px] block">
        Message *
      </label>
      <textarea
        name="message"
        required
        className="
          w-full bg-transparent border-b border-white
          focus:outline-none focus:border-[#B03A2E]
          py-[0px] sm:py-[0px] md:py-[0.5px]
          h-5 sm:h-[5px] md:h-10 resize-none
          text-[7px] sm:text-[3px] md:text-sm
        "
      ></textarea>
    </div>

    <div className="flex justify-center">
      <button
        type="submit"
        className="
          bg-[#B03A2E] text-white
          px-2 sm:px-[2px] md:px-6 py-[1px] sm:py-[0.2px] md:py-2
          rounded-full mt-1 sm:mt-[0.3px] md:mt-3
          hover:bg-[#912626] transition shadow
          text-[7px] sm:text-[3px] md:text-sm font-semibold
        "
      >
        CONTACT US
      </button>
    </div>
  </form>
</div>

      </div>
    </section>
  );
}
